<template>
  <div style="margin-top: 20px">
    <CRow>
      <CCol lg="12">
        <GlobalTable
          :title="'Comunity'"
          :fields="fields"
          :items="comunity"
          :editButton="false"
          :redirectDetail="false"
          :addButton="true"
          :isLoading="isLoading"
          :withCard="false"
          :removeButton="true"
          @addForm="addForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form Comunity</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="voucher_code">Comuninty</label>
              <model-select
                class="form-control"
                id="voucher_code"
                :options="listUserComunity"
                v-model="$v.userComunityForm.comunity_id.$model"
                :isError="$v.userComunityForm.comunity_id.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.userComunityForm.comunity_id.$invalid"
                class="invalid-feedback-custom"
              >
                Comunity should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.userComunityForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UserComunity",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "UserComunity",
      listUserComunity: [],
      addButton: false,
      isEdit: false,
      isLoading: false,
      userComunityForm: tableInterfaces.user_comunity,
      //   checkedFlag: "Agent",
      fields: [
        { key: "comunity_name", label: "Comunity", sorter: true },
        { key: "action", label: "Action" },
      ],
    };
  },
  props: {
    comunity: {
      type: [Array, Object],
      default: () => [],
    },
    userCode: {
      type: String,
      default: null,
    },
  },
  validations: {
    userComunityForm: {
      user_code: {},
      comunity_id: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.$emit("update:userCode", this.userCode);
      this.axios
        .get("console/user_comunity/dropdown")
        .then((response) => {
          if (response.data.status === 2000) {
            this.listUserComunity = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.resetForm();
      this.addButton = true;
    },
    cancelForm: function () {
      this.resetForm();
      this.addButton = false;
    },
    removeData: function (e) {
      if (confirm("Are you sure want to remove this?")) {
        this.isLoading = true;
        this.axios
          .delete("console/user_comunity/remove/" + this.userCode + "/" + e.comunity_id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.$router.go(0);
          });
      }
    },
    resetForm: function () {
      for (var i in tableInterfaces.user_comunity) {
        tableInterfaces.user_comunity[i] = null;
      }
      this.userComunityForm = tableInterfaces.user_comunity;
    },
    submitForm: function (e) {
      e.preventDefault();
      if (confirm("Are you sure want to add this?")) {
        this.isLoading = true;
        this.userComunityForm.user_code = this.userCode;
        this.axios
          .post("console/user_comunity/add", this.userComunityForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.$router.go(0);
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
